module.exports = __webpack_public_path__ + "static/media/data-recovery.9e671078.jpg";